export const environment = {
    production: true,
    oidcAuthority: `${window.location.origin}/api/auth`,
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    searchApiBaseUrl: 'api/search',
    hlsProxyBaseUrl: 'hlsproxy',
    metadataApiBaseUrl: 'api/metadata',
    profileApiBaseUrl: 'api/profile',
    orderApiBaseUrl: 'api/order',
    rightsApiBaseUrl: 'api/rights',
    appVersion: "1.1.0-develop-623",
};
